import { Box, type BoxProps, Spinner, Text } from "@chakra-ui/react";

function Loading({children, ...props}: BoxProps) {
  return (
    <Box textAlign="center" {...props}>
      <Spinner />
      <Text>{children || "Loading..."}</Text>
    </Box>
  );
}

export default Loading;
